if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.engravingAddedButton = document.querySelector('.product-form__submit--engraving-added');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    // client validation before submit
    if (!this.validateRecipientForm()) return;

    this.handleErrorMessage();        
    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    this.querySelector('.loading__spinner').classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    if (this.cart) {
      formData.append(
        'sections',
        this.cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButtonText.classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (!this.cart) {
          if (this.engravingAddedButton) this.engravingAddedButton.click();

          setTimeout(() => {
            window.location = window.routes.cart_url;
          }, 1000);
          return;
        }

        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: response,
          });
        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                this.cart.renderContents(response);
                if (this.engravingAddedButton) this.engravingAddedButton.click();
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
          if (this.engravingAddedButton) this.engravingAddedButton.click();
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');
      });
    }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
      // Client validation email
      validateRecipientForm() {
        // Get the recipient form element
        const recipientFormElement = this.querySelector('recipient-form');
        if (!recipientFormElement) return true;
        
        // Get the section ID from the data attribute
        const sectionId = recipientFormElement.getAttribute('data-section-id');
        if (!sectionId) return true;
        
        // Get the checkbox input
        const checkboxInput = document.getElementById(`Recipient-checkbox-${sectionId}`);
        if (!checkboxInput || !(checkboxInput instanceof HTMLInputElement) || !checkboxInput.checked) return true;

        // Get the email input
        const emailInput = document.getElementById(`Recipient-email-${sectionId}`);
        if (!emailInput || !(emailInput instanceof HTMLInputElement)) return true;
        
        const emailValue = emailInput.value.trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        
        // Get error message elements
        const errorMessageWrapper = recipientFormElement.querySelector('.product-form__recipient-error-message-wrapper');
        if (!errorMessageWrapper) return true;
        
        const errorMessageList = errorMessageWrapper.querySelector('ul');
        const errorMessage = errorMessageWrapper.querySelector('.error-message');
        
        // Clear any existing error messages
        if (errorMessageList) {
          errorMessageList.innerHTML = '';
        }
        
        // Hide the error message wrapper initially
        errorMessageWrapper.setAttribute('hidden', '');
        
        // Get the specific email error element
        const errorMessageId = `RecipientForm-email-error-${sectionId}`;
        const errorMessageElement = document.getElementById(errorMessageId);
        
        // Reset validation state
        emailInput.setAttribute('aria-invalid', 'false');
        emailInput.removeAttribute('aria-describedby');
        
        if (errorMessageElement) {
          errorMessageElement.classList.add('hidden');
        }

        // Check if email is empty
        if (!emailValue) {
          // Show the error message wrapper
          errorMessageWrapper.removeAttribute('hidden');
          
          // Add error to the list if the list exists
          if (errorMessageList) {
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.setAttribute('href', `#Recipient-email-${sectionId}`);
            a.textContent = "Email can't be blank";
            li.appendChild(a);
            li.className = 'error-message';
            errorMessageList.appendChild(li);
          }
          
          // Set the main error message
          if (errorMessage && errorMessage instanceof HTMLElement) {
            errorMessage.textContent = "Please adjust the following:";
          }
          
          // Set the specific field error message
          if (errorMessageElement) {
            const errorTextElement = errorMessageElement.querySelector('.error-message');
            if (errorTextElement && errorTextElement instanceof HTMLElement) {
              errorTextElement.textContent = "Email can't be blank";
              errorMessageElement.classList.remove('hidden');
            }
          }
          
          // Mark the field as invalid
          emailInput.setAttribute('aria-invalid', 'true');
          emailInput.setAttribute('aria-describedby', errorMessageId);
          
          return false;
        }
        
        // Check if email format is valid
        if (!emailRegex.test(emailValue)) {
          // Show the error message wrapper
          errorMessageWrapper.removeAttribute('hidden');
          
          // Add error to the list if the list exists
          if (errorMessageList) {
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.setAttribute('href', `#Recipient-email-${sectionId}`);
            a.textContent = "Email is invalid";
            li.appendChild(a);
            li.className = 'error-message';
            errorMessageList.appendChild(li);
          }
          
          // Set the main error message
          if (errorMessage && errorMessage instanceof HTMLElement) {
            errorMessage.textContent = 'Please check the form';
          }
          
          // Set the specific field error message
          if (errorMessageElement) {
            const errorTextElement = errorMessageElement.querySelector('.error-message');
            if (errorTextElement && errorTextElement instanceof HTMLElement) {
              errorTextElement.textContent = "Email is invalid.";
              errorMessageElement.classList.remove('hidden');
            }
          }
          
          // Mark the field as invalid
          emailInput.setAttribute('aria-invalid', 'true');
          emailInput.setAttribute('aria-describedby', errorMessageId);
          
          return false;
        }

        return true;
      }

      get variantIdInput() {
        return this.form?.querySelector('[name=id]');
      }
    }
  );
}
